import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IncidentSeverityResponse } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.dto'

class IncidentsSeveritiesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<IncidentSeverityResponse>> {
        const response = await axios.put<IResponseAgGrid<IncidentSeverityResponse>>(`/configuration/incidentSeverities`, filterModel, { params })
        return response.data
    }
}

export const incidentsSeveritiesConfigurationServices = new IncidentsSeveritiesConfigurationServices()
